export const ApiURL = "https://api.nationalmedicosorganisation.org"

 //export const ApiURL = "http://localhost:5000";
